import $ from './app/jquery-shim.js';
import Utils from './app/utils.js';
import Accordion from './app/accordion.js';
import Anchor from './app/anchor.js';
import FixedHeader from './app/fixedheader.js';
import HeightLine from './app/heightline.js';
import ResponsiveTable from './app/responsive-table.js';
import Slidebar from './app/slidebar.js';
import Tab from './app/tab.js';
import CurrentNav from './app/current-nav.js';
import buildFormat from './app/format.js';
import myScript from './scripts.js';
import OwlCarousel from 'owl.carousel';
import modaal from 'modaal';


import fontAwesome from "font-awesome/scss/font-awesome.scss";
import OwlCss from "owl.carousel/dist/assets/owl.carousel.css";
import OwlThemeCss from "owl.carousel/dist/assets/owl.theme.default.css";
import lightGalleryCss from 'lightgallery.js/dist/css/lightgallery.css';

class App {
  constructor() {
    this.Utils = new Utils();
    this.Accordion = new Accordion();
    this.Anchor = new Anchor();
    this.FixedHeader = new FixedHeader();
    this.HeightLine = new HeightLine();
    this.ResponsiveTable = new ResponsiveTable();
    this.Slidebar = new Slidebar();
    this.CurrentNav = new CurrentNav();
    this.Tab = new Tab();

    //SPメニューの高さ取得
    function menuHight() {
      var win = $(window).innerWidth();
      if (win > 750) {
        return false;
      }

      var $smpHeaderHeight = $('.l-header').height();
      var windowHeight = window.innerHeight;
      var winH = windowHeight - $smpHeaderHeight;


      //動かすターゲットを取得
      var targetSlidebarWrap = $('.c-slidebar-menu'),
        targetSlidebarMenu = $('.c-slidebar__parent'),
        targetSlidebarBtn = $('.c-slidebar-menu__parent');


      //いざ実行(クリックしたら処理を実行する)
      targetSlidebarBtn.on('click', function () {
        $('.c-slidebar-menu').toggleClass('is-active');
      });
    }


    //フッターメニューSPスライド
    function menuSlide() {
      var win = $(window).innerWidth();
      if (win > 750) {
        return false;
      }
      $('.l-footer__block').on('click', function () {
        $(this).children(".l-footer__menutitle").toggleClass('is-open');
        $(this).children(".l-footer__menulist.is-sub").slideToggle();
      })
    }

    //owlcarousel
    function owlCarousel() {
      var owls = $('.owl-carousel');
      if (owls.length === 0) {
        return false
      }
      //->スライダー
      //->カード_カルーセル
      owls.imagesLoaded(function () {
        var $items = $('.js-card-slider');
        for(var i = 0; i<$items.length;i++){
          $($items[i]).find("")
          var $owl = $($items[i]).owlCarousel({
            dots: false,
            loop: true,
            nav: true,
            autoplayHoverPause: true,
            autoplay: true,
            autoplaySpeed: 800,
            autoWidth: false,
            autoHeight: false,
            center: false,
            navText: ['<i class="fa fa-angle-left" aria-hidden="true"></i>', '<i class="fa fa-angle-right" aria-hidden="true"></i>'],
            responsive: {
              // breakpoint from 0 up
              0: {
                items: 2,
                margin: 20,
              },
              // breakpoint from 750 up
              750: {
                items: 3,
                margin: 40,
              },
              1080: {
                items: 4,
                margin: 40,
              },
              1280: {
                items: 6,
                margin: 40,
              },
            }
          });
        }

      });
    }

    //- お気に入り削除
    function closeButton() {
      $('.c-card__close').on('click', function () {
        $(this).parent().remove();
      })
    }

    function slider() {
      var owls = $('.owl-carousel');
      var subImg = $('.c-block-head__sub__image');
      if (owls.length === 0) {
        return false
      }
      //->スライダー
      //->カード_カルーセル
      owls.imagesLoaded(function () {
        $('.c-block-head__main').owlCarousel({
          dots: false,
          loop: false,
          nav: false,
          items: 1,
          autoplay: false,
          autoWidth: false,
          autoHeight: false,
          center: false,
          URLhashListener: true,
          autoplayHoverPause: true,
          startPosition: 'URLHash',
          //navText: ['<i class="fa fa-angle-left" aria-hidden="true"></i>', '<i class="fa fa-angle-right" aria-hidden="true"></i>'],
        });
      });
      $(subImg).on('click', function () {
        $(subImg).removeClass('is-active');
        $(this).addClass('is-active');
      })
    }

    // modaal
    function modaal() {

    }

    function buttonInteraction() {
      $('.c-block-head__button').on('click', function () {
        $(this).toggleClass('is-active');
      })

      $('.l-header__submenu ul li.is-search').on('click', function () {
        $('.l-header__search').toggleClass('is-active');
      })
    }


    $(function () {
      menuSlide();
      owlCarousel();
      slider();
      closeButton();
      buttonInteraction();
    });
  }
}

window.GApp = new App();
